import React from "react";
import { Star } from "lucide-react";
import { TICKER_ITEMS } from "../mock";

const Ticker = () => {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="ticker">
      <div className="ticker-track">
        {items.map((t, i) => (
          <span key={i}>
            <Star size={12} fill="currentColor" /> {t}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
